<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col
        cols="12"
      >
        <h1 :class="h1Style" class="title-border">
          FAQ
        </h1>
      </v-col>
      <v-col
        cols="12"
        v-for="(qas, i1) in qaList"
        :key="`i1${i1}`"
      >
        <h1 :class="h1Style" class="title-border">
          {{ qas.title[lang] }}
        </h1>

        <v-expansion-panels
          focusable
          accordion
          multiple
          flat
          hover
          tile
        >
          <v-expansion-panel
            v-for="(qa, i2) in qas.qa"
            :key="`i2-${i1}-${i2}`"
          >
            <v-expansion-panel-header>
              {{ qa[lang][0] }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <span v-html="qa[lang][1]"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    lang() {
      return /^\/ja/.test(this.$route.path) ? 0 : 1
    }
  },
  data: () => ({
    options: {
      duration: 700,
      offset: 0,
      easing: 'easeInOutCubic'
    },
    qaList: [
      {
        title: [
          'はじめに',
          'Introduction',
        ],
        qa: [
          [
            [ '"Paike"は、どういう意味ですか。',
              'Paikeは、PassionとLikeから生まれた言葉です！<br />英語には「Paike」という単語はありませんが、エストニア語で、"太陽"を意味する単語のようです。',],
            [ 'What does "Paike" mean?',
              'Paike is a combination of "passion" and "like"!<br />Paike is not a real word in English, but in Estonian it means "sun".',],
          ],
          [
            [ '"Paike"は、何と読めばいいですか。',
              'パイクです！',],
            [ 'How to pronounce "Paike"?',
              `Paike is pronounced “pike”.`,],
          ],
          [
            [ '“Paike out”とは何ですか。',
              '“Paike out（パイクアウト）”とは、同じ「好き」を持った旅行者とローカルが、「好き」を一緒に楽しむことです！<br />たとえ、英語などの外国語が苦手でも、同じ「好き」を持った人と、「好き」を一緒に楽しむだけであれば、「好き」が共通言語として働くので、言葉に関係なく楽しむことができます！',],
            [ 'What is “ Paike out” ?',
              '“Paike out” means hanging out with locals/travelers  who have the same passions/interests/likes as you.<br />You make a new friend through a mutual “Passion&Like” activity without worrying about not speaking the same language. ',],
          ],
        ],
      },
      {
        title: [
          'Paike out全般',
          'Paike out',
        ],
        qa: [
          [
            [ '友だちと一緒にPaike outすることはできますか。',
              'できます！<br />ぜひ、友達や一緒に旅行している方も一緒にPaike outしましょう！Paikeでは、複数人でPaike outすることをおすすめしています。<br />ただし、事前に相手の方（ローカル／旅行者）にもその旨メッセージし、了解を取りましょう！'],
            [ 'Can I meet the locals/travelers with my friends?',
              'Yes, you can bring your friends if you tell the local/travelers in advance.'],
          ],
          [
            [ 'Paikeを利用するのは無料ですか。なぜ、無料なのですか。',
              '無料です。<br />現機能においてPaikeに支払う手数料等は一切ありません。ただし、実際にPaike outするにあたっての実費は、自己負担になります。<br />気軽に、友達と遊ぶような感覚を味わっていただきたく、無料にしています。'],
            [ 'Is it free to use Paike? ',
              'Yes, it is free to use Paike. <br />However, the costs of meals, tickets, or transportation that may occur during your ”Paike out” is at your own expense. '],
          ],
          [
            [ '食事代や入場料などの実費は、誰かに負担してもらえますか。',
              '費用は各自の負担になります。Paike outは、友だちと遊ぶのと同じです。'],
            [ 'Who pays for the meals and admission fees?',
              'You pay for your own expenses. <br />The costs of meals, admission fees, or transportation that may occur during your “Paike out” is at your own expense. '],
          ],
          [
            [ '旅行者は、一緒にPaike outしたローカルに、チップや何かしらのお金を支払う必要はありますか。',
              '支払う必要はありません。<br />あくまでも、友達と遊ぶように「好き」を一緒に楽しんでください。'],
            [ 'Do I pay or tip the locals/travelers who I Paiked out with?',
              'No, you don’t because the locals/travelers are not expected to be a tour guide but a friend. '],
          ],
          [
            [ 'Paike outする時間に、制限はありますか。',
              'ありません。<br />事前に時間を決めましょう。また、もちろん相手の方がOKすれば、その時間を超えてPaike outをしても大丈夫です。'],
            [ 'Is there a limit to the time to Paike out?',
              'There is no limit. <br />You can decide the time beforehand with the local/travelers. '],
          ],
          [
            [ 'ローカルはガイドとして観光地などを案内してくれますか。',
              'ローカルの方はガイドではないので、ガイドはしてくれません。<br />ぜひ、「好き」を一緒に楽しみましょう！'],
            [ 'Will local people give us a guided tour of sightseeing locations?',
              `No. They are not guides but locals, so they don't necessary give you a tour. Enjoy “Passion&Like” together with locals!`],
          ],
          [
            [ '私はローカルですが、旅行者とPaike outするにあたって、どこに行こうか迷っています。',
              '「好き」に関連した地元のお店、自分でよく知った場所で、旅行者の方とPaike outすれば大丈夫です。特別なことをしようとせず、友達と遊ぶ感覚で楽しみましょう！<br />また、旅行者の方に、希望を聞いてみてもいいでしょう。<br />もし困った場合は、お気軽にMessage機能からサポートチームに相談してください。'],
            [ `As a local, I'm not sure where I should take travelers for Paike out.`,
              `You can take them anywhere you know well in your local area related to the mutual “Passion&Like” between you two.<br />You don't need to worry too much about doing something special, but enjoy Paike out with travelers just like with your friends!<br />If you have any questions, please don't hesitate to talk to our Paike Support Team through the messaging tool.`],
          ],
          [
            [ 'Paike outする約束を、キャンセルできますか。',
              '相手の方に了解を得た上でのキャンセルは可能です。しかし、相手の方は、Paike outを楽しみにして予定をたてています。<br />そのため、できる限り、キャンセルは控えましょう。'],
            [ 'Can I cancel a "Paike Out" meet-up?',
              'If the Paike out partner understands the situation you can cancel it. <br />However, the traveler/local is excited and has set aside time for the Paike Out, so please refrain from cancelling as much as possible.'],
          ],
        ],
      },
      {
        title: [
          'Paike out前',
          'Before Paike out',
        ],
        qa: [
          [
            [ '旅行者も、ローカルから探してもらえますか。',
              '探してもらえます。<br />旅行先をPaikeout Areaとして登録し好きなものをShareしてみてください。そうすると、ローカルの方があなたを探すことができます。'],
            [ 'Can travelers also be reached out to by locals?',
              'Yes, there are two ways:<br />1. Go to "Profile" > Go to "Profile" > "Public Info🌐" and share your travel destination as "Paikeout Area".<br />2. Go to "shots" and add your favorite things as "passion shots".<br />Then, local people can reach out to you via the mutual "Paikeout Area" or "passion shots".'],
          ],
          [
            [ 'ローカル側から旅行者を探すことはできますか。',
              'できます。<br />旅行者が、旅行先（あなたの住んでいるエリア/ Paikeout AreaをPaikeout Area）として登録し、好きなものShareしていると、探すことができます。'],
            [ 'Can local people reach out to travelers? ',
              'Yes, it is possible.<br />However, travelers have to set your local area as their "Paikeout area" and also have uploaded "passion shots" (does not matter what area).<br />Sorry, under the current version, it can be a little difficult to reach out to travelers as a local.'],
          ],
          [
            [ '他のコミュニケーションアプリを使ってやり取りすることはできますか？',
              'Paikeを安心・安全にご利用いただくために、PaikeのMessage機能上でのやり取りを強くおすすめしています。'],
            [ 'Can users use other communication tools/apps such as Messenger or Whatsapp?',
              'We strongly recommend for both travelers/locals to communicate on Paike for your safety and privacy.'],
          ],
          [
            [ '旅行者同士／ローカル同士でも、メッセージでやり取りしてもいいでしょうか。',
              'もちろん、問題ありません。<br />ただ、せっかくですから、旅行者／ローカルの方にもメッセージしてみましょう。'],
            [ 'Can a local send messages to another local (and vice-versa)?',
              `Of course, but don't miss out on opportunities to communicate with the travelers/locals who you usually don't get to meet🙂`],
          ],
        ],
      },
      {
        title: [
          '言葉',
          'Language',
        ],
        qa: [
          [
            [ '現地の言葉／英語が離せないのですが・・・。',
              '大丈夫です。<br />「好き」という共通言語があるのですから、言葉に関係なく、楽しめるはずです。<br />まずは、とりあえず気軽にメッセージのやり取りからしてみましょう。'],
            [ `I don't speak the local language/English and I am worried if I can have fun.`,
              'There is no requirement for language skill, so there is a chance the local/traveler does not speak English fluently.<br />By sharing the same “Passion&Like," you explore the new world without a guidebook.<br />Please just keep in mind to talk slowly and clearly.'],
          ],
          [
            [ 'Paike outする相手の方は、英語が流暢に喋れますか。',
              '英語が流暢に喋れない可能性もあります。<br />しかし、Paikeは、「好き」を共通言語に、言葉に関係なく「好き」を一緒に楽しむ機会を提供するサービスです。言葉に関係なく、楽しめるはずです。<br />まずは、とりあえず気軽にメッセージのやり取りからしてみましょう。'],
            [ `Will my new friend speak English fluently?`,
              `He/She might not be fluent in English. However, you will definitely have fun together with the same “Passion&Like”. That is exactly the concept of Paike.<br />Anyway, let's say hello to people who share the same passion!`],
          ],
          [
            [ '表示を日本語など英語以外の言語に切り替えることはできますか？',
              'できません。サービスのメインの部分は英語のみの表示になります。'],
            [ 'Can I change the language on Paike to anything other than English?',
              'Unfortunately no. Main contents on Paike will be shown only in English.'],
          ],
        ],
      },
      {
        title: [
          '好きなもの',
          'Passion',
        ],
        qa: [
          [
            [ '表示される「好き」以外の好きは、選択できないのですか。',
              '"other"として選択していただけます。<br />ぜひ、Message機能を使い、サポートチームに「○○を追加して欲しい！」との声をお寄せください！なるべく早く実現できるように最善を尽くします。'],
            [ `How can I choose "passion shots" that are not shown on "What's your passion shot?"?`,
              `In that case, you can select the "other" tab.<br />Also, you can also let us know by sending messages to our Paike Support Team (e.g. "add ◯◯ as a 'passion'!") via the Message tool on Paike.<br />We will try to add it as soon as possible.`],
          ],
          [
            [ 'この「好き」を追加して欲しいです！',
              'ぜひ、Message機能を使い、サポートチームに「○○を追加して欲しい！」との声をお寄せください！<br />なるべく早く実現できるように最善を尽くします。'],
            [ `I don't see a specific tab in "passion".`,
              `Please send messages to our Paike Support Team (e.g. "add this tab please!") via the Message tool on Paike.<br />We will try adding it as soon as possible.`],
          ],
        ],
      },
      {
        title: [
          '利用可能エリア',
          'Available area',
        ],
        qa: [
          [
            [ '「Tokyo+」は具体的にどの地域ですか。',
              '東京都、神奈川県、埼玉県、千葉県です。'],
            [ `Which areas specifically does "Tokyo+" mean?`,
              `"Tokyo +" indicates: Tokyo(東京) prefecture, Kanagawa(神奈川)  prefecture, Saitama(埼玉) prefecture, and Chiba(千葉) prefecture.`],
          ],
          [
            [ '「Fukuoka+」は具体的にどの地域ですか。',
              '福岡県です。'],
            [ `Which areas specifically does "Fukuoka +" mean?`,
              `"Fukuoka +" indicates Fukuoka prefecture only.`],
          ],
          [
            [ '「Taipei+」は具体的にどの地域ですか。',
              '台北、桃園市、新竹市、基隆市です。'],
            [ `Which areas specifically does "Taipei +" mean?`,
              `"Taipei +" indicates: Taipei City(台北), Taoyuan City (桃園), Hsinchu City(新竹市), and Keelung City (基隆市).`],
          ],
          [
            [ '「Tokyo+」、「Fukuoka+」、「Taipei+」以外の場所で検索できないのですか。',
              '直接の検索はできません。<br />初期段階では東京周辺、福岡周辺、台北周辺に絞っており、その他の地域はotherからご覧ください。<br />東京周辺、福岡周辺、台北周辺以外に「この都市も追加して欲しい！」という声がありましたら、ぜひ、Message機能を使い、サポートチームにその声をお寄せください！なるべく早く実現できるように最善を尽くします。'],
            [ `Can I search areas other than "Tokyo+," "Fukuoka+," and "Taipei+?"`,
              `You cannot directly search other areas for now.<br />Under the current version, main Paikeout areas we set up as a tab are only these around Tokyo, Fukuoka, or Taipei.<br />So please look up other areas in the "other" tab.<br />If there are any specific areas you would like to add, please let us know by sending messages to our Paike Support Team on the Message tool.<br />We will try to add it as soon as possible.`],
          ],
          [
            [ '東京周辺、福岡周辺、台北周辺以外のところに住んでいますが、ローカルとしてPaikeを利用することはできますか。',
              'お使いいただけますが、現在は、東京主編、福岡周辺、台北周辺を重点エリアとしています。ぜひ、お住まいの地域でも、Paikeを広めてください！'],
            [ `Can I still use Paike as a local even though I don't live in Tokyo, Fukuoka, or Taipei?`,
              `Of course! Please note that currently Paikeout areas are focused in Tokyo, Fukuoka, and Taipei, but still it would be our pleasure to have you enjoy Paike and share with your friends in your local area😆`],
          ],
          [
            [ '東京、福岡、台北以外に住んでいる場合は、「好き」をShareしても旅行者から検索されないのですか。',
              '直接の検索はされません。<br />初期段階では東京、福岡、台北に絞っており、検索されにくい状況にあります。ただし、"other"からの検索は可能になっています。<br />東京、福岡、台北以外に「この都市も追加して欲しい！」という声がありましたら、ぜひ、Message機能を使い、サポートチームにその声をお寄せください！なるべく早く実現できるように最善を尽くします。'],
            [ `I want to use Paike as a local, but I don't live in Tokyo, Fukuoka, or Taipei.`,
              `Under the current version, travelers might not easily reach out to you compared to the Tokyo, Fukuoka, and Taipei area.<br />If there are any specific areas you would like to add, please let us know by sending a message to our Paike Support Team with the Message tool. We will try to add it as soon as possible.`],
          ],
        ],
      },
      {
        title: [
          'サインアップ・ログイン',
          'Sign Up・Log In',
        ],
        qa: [
          [
            [ '携帯番号が変わったため、以前の番号でLog Inできません。どうすれば良いですか。',
              '恐縮ですが、support@paikeout.comまでご連絡ください。'],
            [ `I changed my phone number, and thus cannot log in with the former phone number. What should I do?`,
              `Please contact here: support@paikeout.com`],
          ],
          [
            [ '電話番号認証、facebook認証以外に、サインアップする方法はないのですか。',
              '現時点ではありません。<br />Paikeでは、皆さんにより安心・安全にご利用いただくため、現時点においては、電話番号認証、facebook認証によるサインアップに限定しております。ご理解のほど、よろしくお願い致します。'],
            [ `Is there any way to sign up other than signing up with phone number or with facebook?`,
              `Currently no. Paike only accepts phone number signup or facebook signup only, due to user's security and safety.`],
          ],
        ],
      },
      {
        title: [
          'その他',
          'Other',
        ],
        qa: [
          [
            [ '事故などが起こった場合の責任は、どうなりますか。',
              'すべて自己責任になります。<br />Paikeは、マッチングの機会を提供するだけですので、一切の責任は負いかねます。'],
            [ `Who is responsible in the case of an accident? (Limits on Liability)`,
              `Paike provides you with opportunities of hanging out with new friends. We do not control or direct to users what to do, and we are not responsible for their actions or conduct, or their shared contents (whether online or offline).`],
          ],
          [
            [ 'アカウントの削除方法を教えてください。',
              'Message機能でサポートチームに直接ご連絡ください。'],
            [ `How to delete my account?`,
              `Contact our Paike Support Team with the Message tool on Paike.`],
          ],
          [
            [ '「こんな機能をつけて欲しい」「ここが使いにくい！」',
              'ぜひ、Messeage機能を使い、サポートチームにご意見をお寄せください！なるべく早く実現・解決できるように最善を尽くします。'],
            [ `I want to send feedbacks/issues regarding Paike. (e.g. "add this kind of feature." / "please improve ~~" )`,
              `Please send messages to our Paike Support Team via Message tool on Paike. We will try solve/improve them as soon as possible.`],
          ],
        ],
      },
    ],
  }),
};
</script>
